import React, {useCallback, useEffect, useState} from "react";
import EAButton from "../EAButton";
import Switch from "@material-ui/core/Switch";
import {handleApiException, useHttp} from "../../services/HttpService";
import {
    activatePersonalisierungEndpoint,
    deactivatePersonalisierungEndpoint,
    personalisierungEndpoint
} from "../../services/AnwenderService";
import {toast} from "react-toastify";
import PersonalisierungsFilterFieldSet from "./PersonalisierungsFilterFieldSet";
import {
    getAnlagentypEndpoint,
    getBetriebsTypEndpoint,
    getMessstellentypEndpoint,
    getRaeumlicheEndpoint
} from "../../services/WertelistenService";
import EADialog from "../EADialog";
import LoadingPlaceholder from "../LoadingPlaceholder";
import {useForm} from "../../utils/FormUtils";
import {changeFieldValueIfPresent} from "../../utils/ObjectUtils";

export default function PersonalisierungsComponent({setPersonalized}) {
    const [dlgOpen, setDlgOpen] = useState(false);
    const [betriebsTypOptionen] = useHttp(getBetriebsTypEndpoint);
    const [anlagenTypOptionen] = useHttp(getAnlagentypEndpoint);
    const [messstellentypOptionen] = useHttp(getMessstellentypEndpoint);
    const [verwaltungseinheitOptionen] = useHttp(getRaeumlicheEndpoint);
    const {values, setValues, formFactory, submit, submitLoading} = useForm({});
    const [{loading}, loadPersonalisierung] = useHttp(personalisierungEndpoint, {manual: true});
    const [personalisierungActive, setPersonalisierungActive] = useState(false);
    const [{loadingActive}, submitActive] = useHttp({
        url: activatePersonalisierungEndpoint,
        method: "GET",
        data: values
    }, {manual: true});
    const [{loadingInactive}, submitInactive] = useHttp({
        url: deactivatePersonalisierungEndpoint,
        method: "GET",
        data: values
    }, {manual: true});
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!initialized) {
            setInitialized(true);
            loadPersonalisierung()
                .then((res) => {
                    setValues(res.data);
                    setPersonalisierungActive(res.data.active);
                    setPersonalized(res.data.active);
                })
                .catch((e) => handleApiException(e, "ERROR loading Personalisierung"));
        }
    }, [loadPersonalisierung, setValues, setPersonalized, initialized]);

    const renderDialogContent = useCallback(() => {
        return (
            <div className="gridl">
                <p>
                    Sie können einige Filter mit Werten vorbelegen. Die personalisierten Filter bleiben auch nach dem Logout erhalten.
                </p>
                <PersonalisierungsFilterFieldSet
                    betriebstypen={betriebsTypOptionen}
                    anlagentypen={anlagenTypOptionen}
                    messstellentyp={messstellentypOptionen}
                    verwaltungseinheit={verwaltungseinheitOptionen}
                    values={values}
                    setValues={setValues}
                />
                {formFactory.renderCheckbox("sendMailOnNachrichten", "sendMailOnNachrichten", "Nachrichten zusätzlich per E-Mail erhalten")}
                {formFactory.renderCheckbox(
                    "sendMailOnWiedervorlage",
                    "sendMailOnWiedervorlage",
                    "Wiedervorlagen zusätzlich per E-Mail erhalten"
                )}
            </div>
        );
    }, [anlagenTypOptionen, betriebsTypOptionen, formFactory, messstellentypOptionen, setValues, values, verwaltungseinheitOptionen]);

    const preformatValues = useCallback((vals) => {
        changeFieldValueIfPresent(vals, "verwaltungseinheit", "verwaltungseinheit");
        return vals;
    }, []);

    const handleSave = useCallback(() => {
        submit(preformatValues, personalisierungEndpoint, "PUT")
            .then(() => {
                toast.success("Die Personalisierung wurde erfolgreich gespeichert.");
                setDlgOpen(false);
                if (personalisierungActive) {
                    setPersonalized(!personalisierungActive);
                    setPersonalized(personalisierungActive);
                }
            })
            .catch((e) => handleApiException(e));
    }, [submit, preformatValues, personalisierungActive, setPersonalized]);

    useEffect(() => {
        if (personalisierungActive) {
            submitActive().then().catch((e) => handleApiException(e));
        } else {
            submitInactive().then().catch((e) => handleApiException(e));
        }
    }, [personalisierungActive, setValues, submitActive, submitInactive, values])

    return (
        <div style={{display: "flex", alignItems: "center", gridArea: "personalisierung"}}>
            <EADialog
                open={dlgOpen}
                titleChildren="Personalisierung"
                content={loading || loadingActive || loadingInactive || submitLoading ? <LoadingPlaceholder/> : renderDialogContent()}
                closeFunction={() => setDlgOpen(false)}
                onSaveobj={handleSave}
                buttons={
                    <>
                        <EAButton id="crudDlg-Abbrechen" label="Abbrechen" onClick={() => setDlgOpen(false)}/>
                        <EAButton
                            loading={loading || loadingActive || loadingInactive || submitLoading}
                            disabled={loading || loadingActive || loadingInactive || submitLoading}
                            id="crudDlg-Submit"
                            label="Speichern"
                            onClick={handleSave}
                            color="primary"
                        />
                    </>
                }
            />
            <EAButton
                disabled={dlgOpen}
                onClick={() => setDlgOpen(true)}
                id="personalisierung"
                label="Personalisierung"
                variant="text"
                color="primary"
                style={{background: "transparent"}}
            />
            <Switch
                value={personalisierungActive}
                checked={personalisierungActive}
                onChange={(e) => {
                    setPersonalisierungActive(e.target.checked);
                    setPersonalized(e.target.checked);
                }}
            />
        </div>
    );
}
